import TrackerTableCampaign from './TrackerTableCampaign'

// ---- STYLE BASES -----------------------------------------------------------
const HEADER_BASE =
  'bg-[#F9FCF8] text-gray-900  tracking-wide text-sm ' +
  'h-14 align-middle ' +
  'border-b border-[#E8EDE6] border-l border-r font-unbounded'

const CELL_BASE =
  'bg-[#F9FCF8] text-gray-900 ' +
  'px-6 py-4 h-16 align-middle ' +
  'border-b border-[#E8EDE6] border-l border-r'

const FOOTER_BASE =
  'bg-[#F9FCF8] text-gray-900 border-t border-[#E8EDE6] font-unbounded'
// ---------------------------------------------------------------------------

const toNumber = (value) => Number(value || 0)

const getCpa = (row) => {
  const conversions = toNumber(row.conversions)
  return conversions > 0 ? toNumber(row.campaignBudget) / conversions : 0
}

const formatCurrency = (value) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(toNumber(value))

export const COLUMNS = [
  {
    Header: 'M - Links',
    id: 'campaignName',
    accessor: 'campaignName',
    sortType: 'basic',
    textAlign: 'start',
    ml: '5%',
    justifyContent: 'center',
    hide: false,
    headerStyleClasses: `${HEADER_BASE} text-left`,
    styleClasses: `${CELL_BASE} text-left`,
    width: '400%',
    Footer: 'Total',
    footerStyleClasses: `${FOOTER_BASE} text-left px-6 py-3`,
    isSortable: true,
    Cell: (props) => (
      <TrackerTableCampaign
        cellValue={props.value}
        originalRow={props.row.original}
        data={props.data}
        removeData={props.removeData}
      />
    ),
  },
  {
    Header: 'Created',
    id: 'createdAt',
    accessor: (row) => {
      const date = row.createdAt ? new Date(row.createdAt) : null
      return date && !Number.isNaN(date.getTime()) ? date.getTime() : 0
    },
    sortType: 'basic',
    Cell: ({ row }) => row.original.createdAt || '',
    justifyContent: 'center',
    hide: false,
    textAlign: 'center',
    headerStyleClasses: `${HEADER_BASE} text-center`,
    styleClasses: `${CELL_BASE} text-center whitespace-nowrap `,
    width: '150%',
    isSortable: true,
  },
  {
    Header: 'Clicks',
    id: 'clicks',
    accessor: (row) => toNumber(row.clicks),
    sortType: 'basic',
    justifyContent: 'center',
    hide: false,
    headerStyleClasses: `${HEADER_BASE} text-center`,
    styleClasses: `${CELL_BASE} text-center`,
    width: '100%',
    isSortable: true,
    Footer: (props) => {
      let sum = 0
      for (let i = 0; i < props.data.length; i++) {
        sum += toNumber(props.data[i].clicks)
      }
      return sum
    },
    footerStyleClasses: `${FOOTER_BASE} text-center`,
  },
  {
    Header: 'Bot',
    id: 'bot-clicks',
    accessor: (row) => toNumber(row.botClicks),
    sortType: 'basic',
    justifyContent: 'center',
    hide: false,
    textAlign: 'center',
    headerStyleClasses: `${HEADER_BASE} text-center`,
    styleClasses: `${CELL_BASE} text-center`,
    width: '100%',
    isSortable: true,
    Footer: (props) => {
      let sum = 0
      for (let i = 0; i < props.data.length; i++) {
        sum += toNumber(props.data[i].botClicks)
      }
      return sum
    },
    footerStyleClasses: `${FOOTER_BASE} text-center`,
  },
  {
    Header: 'CPA',
    id: 'cpa',
    accessor: (row) => getCpa(row),
    sortType: 'basic',
    Cell: ({ value }) => formatCurrency(value),
    justifyContent: 'center',
    hide: false,
    headerStyleClasses: `${HEADER_BASE} text-center`,
    styleClasses: `${CELL_BASE} text-center`,
    width: '100%',
    isSortable: true,
    Footer: (props) => {
      let sum = 0
      for (let i = 0; i < props.data.length; i++) {
        sum += getCpa(props.data[i])
      }
      return formatCurrency(sum)
    },
    footerStyleClasses: `${FOOTER_BASE} text-center`,
  },
  {
    Header: 'Conversions',
    id: 'conversions',
    accessor: (row) => toNumber(row.conversions),
    sortType: 'basic',
    justifyContent: 'center',
    hide: false,
    headerStyleClasses: `${HEADER_BASE} text-center`,
    styleClasses: `${CELL_BASE} text-center`,
    width: '100%',
    isSortable: true,
    Footer: (props) => {
      let sum = 0
      for (let i = 0; i < props.data.length; i++) {
        sum += toNumber(props.data[i].conversions)
      }
      return sum
    },
    footerStyleClasses: `${FOOTER_BASE} text-center`,
  },
]

export const ORDER = [
  'campaignName',
  'createdAt',
  'clicks',
  'bot-clicks',
  'cpa',
  'conversions',
  'dashboard',
]
